import {
  NAVIGATION_RECEIVE,
  NAVIGATION_SET_CURRENT_CATEGORY,
} from '../constants';

export const navigation = (state = { menu: [] }, action) => {
  switch (action.type) {
    case NAVIGATION_RECEIVE:
      return {
        ...state,
        ...action.payload,
      };
    case NAVIGATION_SET_CURRENT_CATEGORY:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};
